import { render, staticRenderFns } from "./objTableSelected.vue?vue&type=template&id=74e6498e&"
import script from "./objTableSelected.vue?vue&type=script&lang=ts&"
export * from "./objTableSelected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports